import { render, staticRenderFns } from "./AdminParameters.vue?vue&type=template&id=20a31dbd&scoped=true&"
var script = {}
import style0 from "./AdminParameters.vue?vue&type=style&index=0&id=20a31dbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a31dbd",
  null
  
)

export default component.exports